/**
 * 
 * @param {string[]} allowedResources - Array of resource keys from backend
 * @param {object} resourceTranslations - Translated resources object from useTranslatedObject("header.resources")
 * @returns {Array<{name: string, url: string}>} - Array of resource objects with name and url
 */
export function getResourcesFromAllowedKeys(allowedResources = [], resourceTranslations = {}) {
  if (!Array.isArray(allowedResources) || allowedResources.length === 0) {
    return [];
  }

  return allowedResources
    .filter(key => resourceTranslations[key])
    .map(key => resourceTranslations[key]);
}